import axios from "axios";
import { PaginatedResponse } from "models/common/responseObjects";
import { ProductPbsManufacturer } from "models/dbModels/products/ProductPbsManufacturer";
import { ProductsPbsManufacturerSearchFilterQuery } from "models/filters/products/ProductsPbsManufacturerSearchFilterQuery";

export class PbsManufacturesApi {
    static Search = async (query: ProductsPbsManufacturerSearchFilterQuery) => axios.post<PaginatedResponse<ProductPbsManufacturer[]>>(`api/v1/PbsManufactures/Search`, query);
}